<style lang="less">
  .order-status {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    font-weight: bold;
  }

  .order-status-making {
    background: #449df3;
    color: white;
  }
  .order-status-waiting {
    background: #f0ac11;
    color: white;
  }
  .order-status-paid {
    background: green;
    color: white;
  }
  .order-status-canceled {
    background: gray;
    color: white;
  }
  .order-status-sent {
    background: #9b9b9b;
    color: white;
  }
</style>

<template lang="pug">
  .order-status(:class="status_name") {{status_text}}
</template>

<script>
import happytree from '@/happytree';

export default {
  mounted() {
    this.init(this.status);
  },
  methods: {
    init(status) {
      this.status_name = 'order-status-making';
      this.status_text = '조제중';

      switch (status) {
        case happytree.status.pending:
          this.status_name = 'order-status-waiting';
          this.status_text = '접수대기';
          break;

        case happytree.status.paid:
          this.status_name = 'order-status-paid';
          this.status_text = '결제완료';
          break;

        case happytree.status.sent:
          this.status_name = 'order-status-sent';
          this.status_text = '발송완료';
          break;

        case happytree.status.canceled:
          this.status_name = 'order-status-canceled';
          this.status_text = '취소됨';
          break;

        default: break;
      }
    },
  },
  props: {
    status: String,
  },
  data() {
    return {
      status_name: '',
      status_text: '',
    };
  },
};
</script>




// WEBPACK FOOTER //
// src/components/order_status.vue